import Vue from 'vue'
import ImgFrame from '@/components/ImgFrame/index'

let defaulUrl = require('@/assets/default_img.png')
Vue.directive('img', {
  inserted: function (el, binding) {
    el.addEventListener('error', function (e) {
      this.src = defaulUrl
    })
  },
  unbind: function (el, binding) {
    el = null
  }
})

Vue.directive('img-frame', {
  inserted: function (el, binding) {
    el.style.cursor = 'pointer'
    el.addEventListener('click', function () {
      ImgFrame.showLayer(el.src)
    })
  }
})

Vue.directive('img-auto', {
  inserted: function (el, binding) {
    el.style.display = 'none'
    el.onload = function () {
      if (el.width > el.height) {
        el.style.display = 'block'
        el.style.width = '100%'
        el.style.height = 'auto'
      } else {
        el.style.display = 'block'
        el.style.height = '100%'
        el.style.width = 'auto'
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/directive/index.js